import { find, propEq, without } from 'ramda'

/*
 * Given an array of comments and a commentId, find the comment
 * @sig findComment :: (number, [Object]) -> MapNote
 */
const findComment = (commentId, mapNoteComments) => find(propEq(commentId, 'id'))(mapNoteComments)

/*
 * Given a comment to be deleted and an array of comments, remove that comment from the array and return
 * @sig findComment :: (number, [Object]) -> MapNote
 */
const updateComment = (comment, mapNoteComments) => without([comment], mapNoteComments)

export {
    findComment,
    updateComment,
}
